import { useTranslation } from 'react-i18next'
import { Card } from '@mui/material'
import { Button, Grid } from '@dhl/theme'
import { StepNavigation } from '~/basket/view/withBasket'

type Props = {
  stepNavigation: StepNavigation
  disabled: boolean
}

export const NavigatorDesktop = ({ stepNavigation, disabled }: Props) => {
  const { t } = useTranslation()

  return (
    <Card
      sx={(theme) => ({
        padding: `${theme.spacing(3)} ${theme.spacing(2)}`,
        marginTop: theme.spacing(2),
        width: '100%',
      })}
    >
      <Grid container direction="row" justifyContent="space-between">
        <Button
          id="previous"
          variant="outlined"
          color="primary"
          disabled={stepNavigation.previousSteps.length === 0}
          onClick={() => stepNavigation.goToPreviousStep()}
        >
          <span>{t('back')}</span>
        </Button>

        <Button
          id="next"
          variant="contained"
          color="primary"
          type="submit"
          disabled={disabled}
          onClick={() => {
            stepNavigation.goToNextStep()
          }}
        >
          <span>{t('next')}</span>
        </Button>
      </Grid>
    </Card>
  )
}
